import { apiClient } from '@/lib/api-client'
import { GetUploadUrlRequest, GetUploadUrlResponse } from '@shared/types/api'

export interface ApplicantDetails {
  id: string
  email: string
  firstName: string
  lastName: string
  phone: string
  status: string
  qualificationPath?: 'VIDEO' | 'INTERVIEW'
  scriptVersion?: string
  scriptDownloadedAt?: string
  videoUrl?: string
  videoUploadedAt?: string
  interviewId?: string
  interviewScheduledAt?: string
  reviewedBy?: string
  reviewedAt?: string
  reviewNotes?: string
}

interface ScriptInfo {
  version: string
  key: string
  active: boolean
  updatedAt: string
  size: number
}

export const applicantService = {
  getLatestScriptVersion: async (token: string): Promise<string | null> => {
    const data = await apiClient.get<{ scripts: ScriptInfo[] }>('/scripts', token)
    return data.scripts.length > 0 ? data.scripts[0].version : null
  },

  getScriptDownloadUrl: (version: string, token: string) =>
    apiClient.get<{ content: string; version: string }>(
      `/scripts/${version}`,
      token
    ),

  getVideoUploadUrl: (data: GetUploadUrlRequest, token: string) =>
    apiClient.post<GetUploadUrlResponse>('/uploads/video/presigned', data, token),

  confirmVideoUpload: (applicantId: string, videoUrl: string, token: string) =>
    apiClient.post<{ status: string; videoUrl: string; videoUploadedAt: string }>(
      `/applicants/${applicantId}/video`,
      { videoUrl },
      token
    ),

  getApplicantDetails: (applicantId: string, token: string) =>
    apiClient.get<ApplicantDetails>(`/applicants/${applicantId}`, token),
}
